export default{
    item: {
        index: 'item-index',
    }
}